var _path, _path2, _g, _path3, _path4, _path5, _path6, _path7, _g2, _path8, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgRobot = function SvgRobot(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 62,
    height: 62,
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#Robot_svg__a)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "m45.11 55.55-3.892-3.105-.03-.022c-.81-.648-1.22-.974-1.677-1.207a5.1 5.1 0 0 0-1.297-.453c-.508-.104-1.038-.104-2.1-.104h-19.65c-2.855 0-4.285 0-5.376-.555a5.1 5.1 0 0 1-2.233-2.227C8.3 46.79 8.3 45.365 8.3 42.517V28.159c0-2.847 0-4.273.556-5.361a5.1 5.1 0 0 1 2.234-2.226c1.093-.555 2.521-.555 5.382-.555h27.105c2.86 0 4.291 0 5.384.555a5.1 5.1 0 0 1 2.231 2.226c.557 1.09.557 2.517.557 5.37v24.201c0 2.715 0 4.071-.558 4.768a2.56 2.56 0 0 1-1.998.958c-.895 0-1.958-.849-4.083-2.544"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "Robot_svg__b",
    width: 15,
    height: 6,
    x: 23,
    y: 39,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M36.567 39.722c.623.352.844 1.141.395 1.693a8.6 8.6 0 0 1-2.447 2.063 8.8 8.8 0 0 1-4.345 1.141 8.8 8.8 0 0 1-4.345-1.141 8.7 8.7 0 0 1-2.447-2.063c-.449-.552-.228-1.34.395-1.694.624-.352 1.412-.13 1.896.391.421.454.913.844 1.46 1.153a6.2 6.2 0 0 0 3.041.799 6.2 6.2 0 0 0 3.041-.799 6 6 0 0 0 1.46-1.153c.484-.522 1.272-.744 1.896-.39"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#Robot_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: 5,
    d: "M36.567 39.722c.623.352.844 1.141.395 1.693a8.6 8.6 0 0 1-2.447 2.063 8.8 8.8 0 0 1-4.345 1.141 8.8 8.8 0 0 1-4.345-1.141 8.7 8.7 0 0 1-2.447-2.063c-.449-.552-.228-1.34.395-1.694.624-.352 1.412-.13 1.896.391.421.454.913.844 1.46 1.153a6.2 6.2 0 0 0 3.041.799 6.2 6.2 0 0 0 3.041-.799 6 6 0 0 0 1.46-1.153c.484-.522 1.272-.744 1.896-.39Z"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M23.334 32.709a.578.578 0 0 0 .581-.657 4.47 4.47 0 0 0-1.18-2.45 4.1 4.1 0 0 0-2.963-1.287 4.1 4.1 0 0 0-2.963 1.287 4.47 4.47 0 0 0-1.18 2.45.578.578 0 0 0 .58.657c.348 0 .622-.299.696-.654.12-.572.392-1.101.792-1.521.55-.577 1.297-.9 2.075-.9s1.524.323 2.074.9c.4.42.673.95.792 1.52.074.356.348.655.696.655M44.326 32.709a.578.578 0 0 0 .581-.657 4.47 4.47 0 0 0-1.18-2.45 4.1 4.1 0 0 0-2.963-1.287 4.1 4.1 0 0 0-2.963 1.287 4.47 4.47 0 0 0-1.18 2.45.578.578 0 0 0 .58.657c.348 0 .623-.299.696-.654.12-.572.392-1.101.793-1.521.55-.577 1.296-.9 2.074-.9s1.524.323 2.074.9c.4.42.673.95.792 1.52.074.356.348.655.696.655M29.012 13.67h2.511l1.674 6.346h-5.858z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "Robot_svg__c",
    width: 62,
    height: 16,
    x: -1,
    y: 28,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M.976 33.709c0-2.538 2.099-4.595 4.687-4.595h1.562v13.783H5.663c-2.588 0-4.687-2.057-4.687-4.594z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M1.953 34.666c0-2.538 2.098-4.594 4.686-4.594h.586v11.676H6.64c-2.588 0-4.686-2.057-4.686-4.594z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M59.559 33.709c0-2.538-2.098-4.595-4.687-4.595H53.31v13.783h1.562c2.589 0 4.687-2.057 4.687-4.594z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M58.583 34.666c0-2.538-2.099-4.594-4.687-4.594h-.586v11.676h.586c2.588 0 4.687-2.057 4.687-4.594z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#Robot_svg__c)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M69.323-7.637h-78.11v76.566h78.11z"
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: 2,
    d: "M37.59 7.811c0-3.775-3.278-6.835-7.322-6.835s-7.323 3.06-7.323 6.835 3.278 6.835 7.323 6.835c4.044 0 7.322-3.06 7.322-6.835Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "Robot_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h62v62H0z"
  })))));
};
export { SvgRobot as ReactComponent };
export default __webpack_public_path__ + "75a111ac5bd2226e8a121406139284bd.svg";